export default {
  loading: {
    id: 'bo_seller.homepage.loading',
    defaultMessage: 'Loading...',
  },
  tradeIn: {
    id: 'bo_seller.homepage.trade_in',
    defaultMessage: 'Trade In',
  },
  lastSevenDays: {
    id: 'bo_seller.homepage.trade_in.last_seven_days',
    defaultMessage: 'Last 7 days',
  },
  viewDetails: {
    id: 'bo_seller.homepage.trade_in.view_details',
    defaultMessage: 'View details',
  },
  ordersOnTheMove: {
    id: 'bo_seller.homepage.trade_in.orders_received',
    defaultMessage: 'Orders received',
  },
  ordersRequireAction: {
    id: 'bo_seller.homepage.trade_in.orders_require_action',
    defaultMessage: 'Orders that require action',
  },
  shipped: {
    id: 'bo_seller.homepage.trade_in.shipped',
    defaultMessage: '{count} shipped',
  },
  delivered: {
    id: 'bo_seller.homepage.trade_in.delivered',
    defaultMessage: 'delivered',
  },
  toProcess: {
    id: 'bo_seller.homepage.trade_in.to_process',
    defaultMessage: 'to process',
  },
  toReplyTo: {
    id: 'bo_seller.homepage.trade_in.to_reply_to',
    defaultMessage: 'to reply to',
  },
  noOrders: {
    id: 'bo_seller.homepage.trade_in.no_orders',
    defaultMessage: 'No orders yet.',
  },
}
